import type { PartnerPlugin } from '@/types/partner'

import DoityPlugin from './plugins/doity'

export function getAllPartners() {
  return [DoityPlugin]
}

export function findMatchingPartner(
  params: Parameters<PartnerPlugin['match']>[0]
) {
  return getAllPartners().find(p => {
    try {
      return p.match(params)
    } catch (e) {
      return false
    }
  })
}
